import {animate, style, transition, trigger} from '@angular/animations';
import {Location} from '@angular/common';
import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {Guid} from 'guid-typescript';
import {Observable, of, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SetCurrentRightSideComponentAction} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {GraphqlContentScope} from '@shared/models/graphql-content-scope.model';
import {QueryProvider} from '@shared/queries/query-provider';
import {QuickViewState} from '@shared/quick-view/quick-view.reducer';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {TaskManagerService} from '../../../../task-manager/services/task-manager.service';
import {TaskManagerState} from '../../../../task-manager/store/task-manager.reducer';
import {
  DeleteConversationMessageAction, EditConversationMessageAction,
  GetConversationSuccessAction,
  MessageReadAction,
  SendMessageAction
} from '../../store/collaboration.action';
import {
  DeleteConversationMessageCommand, EditConversationMessageCommand, MessageReadCommand,
  SendMessageCommand
} from '../../store/collaboration.command';
import {
  HelpSupportComponentName
} from '../../store/collaboration.constants';
import {CollaborationState} from '../../store/collaboration.reducer';
import {getCreatedSupportTask} from '../../../../task-manager/store/task-manager.selector';
import {CollaborationHelper} from '../../store/collaboration.helper';
import {CollaborationConfig} from '../../store/collaboration.config';
import {CollaborationQuery} from '../../store/collaboration.query';
import {TaskManagerHelper} from '../../../store/task-manager.helper';
import {ChatEditorOutput} from '@shared/models/chat-editor.model';
import {BehaviorSubject, Subscription} from 'rxjs';
import {getUserInfo} from '@shared/store/selectors/security.selector';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {UserModel} from '@shared/models/user.model';
import {DialogService} from '@shared/services/dialog-service';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {catchError, map, take} from 'rxjs/operators';
import {SnackBarService} from '@core/services/snack-bar.service';
import {GraphQLService} from '@core/services/graphql.service';
import {SocketClusterService} from '@core/services/socket-cluster.service';
import {
  getCurrentChatConversation, getDeletedMessageId, getEditedMessage,
  getNewChat
} from "../../store/collaboration.selector";
import {StringUtility} from "@shared/utility/string-utility";
import {SupportIssues} from "@shared/Types/Enums";

@Component({
    standalone: false,
    selector: 'particle-support-chat',
  templateUrl: './support-chat.component.html',
  styleUrls: ['./support-chat.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({opacity: '0'}),
        animate('.5s ease-out', style({opacity: '1'}))
      ])
    ])
  ]
})
export class SupportChatComponent implements OnInit, OnDestroy {
  data: any;
  currentChatConversation$: any;
  currentChatConversation: any;
  newChat$: any;
  newChat: any;
  chatText: any;
  chatTextToSend: any;
  messages: any[];
  isMessageInitialized: boolean;
  showMessageInitialization: boolean;
  queryKey: string = 'myOpenSupportTickets';
  myOpenSupportTickets$: Observable<any>;
  myOpenSupportTickets: any[];
  ticketsSelectorControl: any;
  newTaskTypeControl: any;
  newTicketId: string;
  richItems: any;
  currentConversationId: any;
  currentContextId: any;
  focusEditor$: BehaviorSubject<Boolean> = new BehaviorSubject(true);
  private ngUnsubscribe = new Subject<void>();
  @ViewChild('messagecontainer', {static: true}) private messagecontainer: ElementRef;
  currentUser: UserModel;
  richMessage: any;
  scope: number;
  unsubscribingChannel: Subscription;
  newIssueTypes: Array<string> = [];
  systemMessages: any[];
  startingMessageInputDialog: any;
  notificationCheckMessage: any;
  selectedIssue: string;
  defaultText: string;

  constructor(private collaborationStore: Store<CollaborationState>,
              private quickViewStore: Store<QuickViewState>,
              private platformSidebarStore: Store<PlatformSidebarState>,
              private taskManagerStore: Store<TaskManagerState>,
              public dialog: MatDialog,
              private router: Router,
              private socketClusterService: SocketClusterService,
              public securityStore: Store<SecurityState>,
              private commandService: CommandService,
              private snackbarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService,
              public dialogService: DialogService,
              private queryStore: Store<IQueryState>,
              private graphQLService: GraphQLService,
              private taskManagerService: TaskManagerService) {
    this.richItems = null;
    this.currentChatConversation = null;
  }

  ngOnInit() {
    this.initiate();
    this.isMessageInitialized = false;
    this.scope = 3;
    this.myOpenSupportTickets = [];
    this.messages = [];
    this.ticketsSelectorControl = new FormControl('', []);
    this.newTaskTypeControl = new FormControl('', []);
    this.securityStore.select(getUserInfo).pipe(takeUntil(this.ngUnsubscribe)).subscribe(currentUser => {
      this.currentUser = currentUser;
    });
    QueryProvider.invokeQuery(this.queryStore, this.queryKey, null);
    this.myOpenSupportTickets$ = this.queryStore.pipe(select(getQueryResponse, this.queryKey));
    this.myOpenSupportTickets$.pipe( take(2) ).subscribe(state => {
      if (state && state.myOpenSupportTickets) {
        this.myOpenSupportTickets = state.myOpenSupportTickets;
      }
    });

    this.taskManagerStore.pipe(select(getCreatedSupportTask)).subscribe(lastAddedTask => {
      if (this.newTicketId && this.newTicketId === lastAddedTask.Id) {
        this.creaateConversation(lastAddedTask);
        this.showSupportTicket(lastAddedTask);
      }
    });
    this.ticketsSelectorControl.valueChanges.subscribe(existingTicket => {
      this.onSelectExistingTicket(existingTicket);
    });
    this.newTaskTypeControl.valueChanges.subscribe(newTicket => {
      this.onSelectNewTicket(newTicket);
    });

    this.collaborationStore.select(getNewChat).pipe(takeUntil(this.ngUnsubscribe)).subscribe((newReply: any) => {
      if (newReply && this.currentConversationId && this.currentConversationId === newReply.conversationId &&
        this.currentContextId === newReply.parentId) {
        //console.log('got new reply in support chat:', newReply);
        this.handleNewMessage(newReply);
      }
    });

    this.collaborationStore.select(getEditedMessage).pipe(takeUntil(this.ngUnsubscribe)).subscribe((editedMessage: any) => {
      if (editedMessage && this.currentConversationId && this.currentConversationId === editedMessage.conversationId &&
        this.currentContextId === editedMessage.parentId) {
       // console.log('got edited reply in support chat:', editedMessage);
        this.handleEditedMessage(editedMessage);
      }
    });

    this.collaborationStore.select(getDeletedMessageId).pipe(takeUntil(this.ngUnsubscribe)).subscribe((deletedMessageId: any) => {
      if (deletedMessageId) {
        //console.log('got new deletedd message id in support chat:', deletedMessageId);
        this.handleDeletedMessage(deletedMessageId);
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    //this.unsubscribingChannel.unsubscribe();
    this.disconnectChannel();
  }

  initMessage() {
    this.messages.push({
      message: this.chatTextToSend,
      isTemporary: true,
      isMine: true,
      systemMessageType: 'NON_SYSTEM_MESSAGE',
      createdDate: new Date()
    });

    setTimeout(() => this.showCreateTaskSelectTaskView(), 1000);
  }

  private showCreateTaskSelectTaskView() {
    if (this.myOpenSupportTickets && this.myOpenSupportTickets.length > 0) {
      this.messages.push({
        message: 'Thanks for contacting Orbitax. Is this a new issue or an issue that is already open?',
        isMine: false,
        isTemporary: true,
        createdDate: new Date(),
        systemMessageType: 'NON_SYSTEM_MESSAGE'
      });
    } else {
      this.messages.push({
        message: 'Thanks for contacting Orbitax. A member of the team will get back to you shortly.',
        isMine: false,
        isTemporary: true,
        createdDate: new Date(),
        isSystemGenerated: true,
        systemMessageType: 'NON_SYSTEM_MESSAGE'
      });
    }
  }

  showSupportTicket(ticket: any, newTask: boolean = false) {
    const title = ticket.displayTitle ? ticket.displayTitle : `${ticket.DisplayId}-${ticket.Title}`;
    let messageText = '';
    if (this.ticketsSelectorControl.value) {
      messageText = `[Ok. We've sent your additional details to the Orbitax team. You\'ll be notified via Support Ticket (] [anchor1] [) and by email when you receive a response.]`;
    } else if (this.newTaskTypeControl.value) {
      messageText = `[Thank you. Your request has been sent to the Orbitax team. You\'ll be notified via Support Ticket (][anchor1][) and by email when you receive a response.]`;
    }
    this.richMessage = {
      message: messageText,
      isMine: false,
      isTemporary: true,
      isSystemGenerated: true,
      createdDate: new Date(),
      type: 'SpeechWithAction',
      id: Guid.create().toString(),
      metadata: {
        anchor1: {
          id: 'anchor1',
          text: title,
          parameter: ticket.id ? ticket.id : ticket.Id,
          type: 'anchor'
        }
      }
    };
    this.richItems = CollaborationHelper.convertMessageToDynamicChatParameter(this.richMessage);
    // messageText = `[Ok. Your issue has been sent to the Orbitax team. You\'ll be notified via Support Ticket(] [anchor1] [) and by email when you receive a response.]`;
    // messageText = `[Please keep an eye out for email updates from. You\'ll be notified via Support Ticket(] [anchor1] [) and by email when you receive a response.]`;
    this.notificationCheckMessage = {
      message: `Please keep an eye out for email updates from notification@orbitax.com (you may need to check your spam/junk folder).`,
      isMine: false,
      isTemporary: true,
      isSystemGenerated: true,
      createdDate: new Date(),
      systemMessageType: 'NON_SYSTEM_MESSAGE',
      id: Guid.create().toString(),
      metadata: {
        anchor2: {
          id: 'anchor2',
          text: title,
          parameter: ticket.id ? ticket.id : ticket.Id,
          type: 'anchor'
        }
      }
    };
    this.messages.push(this.richMessage);
    this.messages.push(this.notificationCheckMessage);

  }

  onClick(key: string) {
    // console.log(key);
  }

  sendMessage(chatEditorOutput: ChatEditorOutput) {
    this.chatText = chatEditorOutput.chatText;
    this.chatTextToSend = this.getPlainText(this.chatText);
    let messageId = Guid.create().toString();
    this.appendNewChat({
      isTemporary: true,
      createdDate: new Date(),
      isMine: true,
      message: this.chatTextToSend,
      systemMessageType: 'NON_SYSTEM_MESSAGE',
      messageType: 1,
      id: messageId
    });
    // console.log('message:', this.messages);
    if (this.isMessageInitialized === false) {
      setTimeout(() => this.createTask(), 200);
    } else {
      const sendMessageCommand = new SendMessageCommand(this.currentChatConversation.id, this.chatTextToSend, 1, this.currentContextId);
      sendMessageCommand.scope = this.scope;
      sendMessageCommand.messageId = messageId;
      //this.collaborationStore.dispatch(new SendMessageAction(sendMessageCommand));
      this.commandService.executeCommand(sendMessageCommand).pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => {
        //console.log('new message added in support chat:', response);
        if(response && response.Payload) {
          const message = StringUtility.convertKeysPascalToCamel(response.Payload);
          this.handleNewMessage(message);
        }
      });
    }
    this.chatText = '';
  }

  private appendNewChat(newChat) {
    this.messages.push(newChat);
    this.newChat = newChat;
    this.scrollToBottom();
  }

  removeMessage(messageObj, deleteForEveryOne = true) {
    const messageId = messageObj.id;
    const deleteConversationMessageCommand = new DeleteConversationMessageCommand(messageId, deleteForEveryOne);
    deleteConversationMessageCommand.scope = this.scope;
    this.collaborationStore.dispatch(new DeleteConversationMessageAction(deleteConversationMessageCommand));
  }

  navigateToHelpAndSupport() {
    this.ngOnDestroy();
    this.collaborationStore.dispatch(new GetConversationSuccessAction(null, null));
    this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction({
      component: HelpSupportComponentName,
      data: {},
      componentInfo: null
    }));
  }

  editMessage(messageObj: any) {
    this.dialogService.showChatMessageEditorDialog('Edit Message', messageObj.message, 'Message')
      .pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      if (state.action === 'OK') {
        // console.log('Edit', state);
        const command = new EditConversationMessageCommand(messageObj.id, state.data.input.text);
        command.scope = this.scope;
        //this.collaborationStore.dispatch(new EditConversationMessageAction(command));
        this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(response => {
          //console.log('edit message added in support chat:', response);
          if(response && response.Payload) {
            const message = StringUtility.convertKeysPascalToCamel(response.Payload);
            this.handleEditedMessage(message);
          }
        });
      }
    });
  }

  markReadIfNeeded() {
    if (this.currentChatConversation.unreadMessageCount > 0) {
      this.collaborationStore.dispatch(new MessageReadAction(new MessageReadCommand(this.currentChatConversation.id, true)));
    }
  }

  scrollToBottom(): void {
    if (this.messagecontainer) {
      setTimeout(() => {
        this.messagecontainer.nativeElement.scrollTop = this.messagecontainer.nativeElement.scrollHeight;
      }, 500);
    }
  }

  createNewTask(subject) {
    this.newTicketId = Guid.create().toString();
    this.taskManagerService.createSupportTask('orbitax_support', this.newTicketId, 'Pending', subject, this.chatTextToSend, false);
  }

  openOldTask() {
    const taskSelectorValue = this.ticketsSelectorControl.value;
    if (!taskSelectorValue) {
      return;
    }
   // this.showSupportTicket(taskSelectorValue);
    this.creaateConversation({
      Id: taskSelectorValue.id,
      Description: this.chatTextToSend,
      DisplayId: taskSelectorValue.displayId
    }, taskSelectorValue);
  }

  //todo: shakil need to remove
    private subscribeToNewChat () {
   this.newChat$ = this.collaborationStore.select(getNewChat).pipe(
   takeUntil(this.ngUnsubscribe));
   this.newChat$.subscribe(newChat => {
   //console.log('nwe message:', newChat);
   if (!this.currentChatConversation || !newChat) {
   return;
   }
   if (newChat.createdBy.email === this.currentUser.email) {
   newChat.isMine = true;
   }
   this.messages.push(newChat);
   this.newChat = newChat;
   this.scrollToBottom();
   });
   }

   private SubscribeToCurrentChatConversation () {
   this.currentChatConversation$ = this.collaborationStore.select(getCurrentChatConversation).pipe(
   takeUntil(this.ngUnsubscribe));
   this.currentChatConversation$.subscribe(currentChatConversation => {
   //console.log('got current chat conversation:', currentChatConversation, this.currentChatConversation, this.messages);
   this.currentChatConversation = currentChatConversation;
   if (this.currentChatConversation && this.currentChatConversation.messages && this.currentChatConversation.messages.length && this.messages) {
   this.messages = this.currentChatConversation.messages;
   if (this.richMessage) {
   this.messages.unshift(this.richMessage);
   }
   if (this.currentChatConversation.initialMessage) {
   this.messages.unshift(this.currentChatConversation.initialMessage);
   }
   this.scrollToBottom();
   this.markReadIfNeeded();
   }
   });
   }
   subscribeToDeleteMessageNotification() {
   this.collaborationStore.select(getDeletedMessageId).pipe(
   takeUntil(this.ngUnsubscribe)).subscribe((id: string) => {
   if (id && this.messages) {
   this.changeMessageDeleteProperty(id);
   }
   });
   }

   public changeMessageDeleteProperty(id: string) {
   const newMessages = this.messages.map(message => message.id);
   const messageIndex = newMessages.indexOf(id);
   if (messageIndex > -1) {
   this.messages = this.messages.filter(message => message.id !== id);
   /*this.collaborationStore.dispatch(new GetConversationAction(CollaborationConfig.CollaborationApiKey,
   CollaborationQuery.getConversationById(this.currentChatConversation.id, this.currentChatConversation.scope), SupportChatComponentName));*/
   }
   }

  onActionPerformed(data) {
    this.taskManagerService.openTaskByTaskId(data.parameter, GraphqlContentScope.getScope(3));
  }

  creaateConversation(lastAddedTask, taskSelectorValue = null) {
    const command = TaskManagerHelper.CreateSupportConversationCommand(lastAddedTask);
    this.fuseSplashScreenService.show();
    this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      this.fuseSplashScreenService.hide();
      if (state && state.Payload && state.Payload.Id) {
        this.currentConversationId = state.Payload.Id;
        this.currentContextId = state.Payload.ParentId;
        //console.log('create conversation:', state, this.currentContextId);
        if (taskSelectorValue) {
          this.showSupportTicket(taskSelectorValue);
        }
        this.currentChatConversation = null;
        this.messages = [];
        this.isMessageInitialized = true;
        this.fetchConversation();
      }
    } , err => {
      this.fuseSplashScreenService.hide();
      this.snackbarService.showError('Create Conversation failed.');
    });
  }

  fetchConversation() {
    const query = CollaborationQuery.getConversationById(this.currentConversationId, GraphqlContentScope.getScope(3));
    this.graphQLService.executePostRequest(CollaborationConfig.CollaborationApiKey, query).pipe(take(1))
      .subscribe(payload => {
        //console.log('fetch conversation:', this.currentConversationId, payload);
        if (payload && payload.data && payload.data.conversation) {
          this.prepareConversation(payload.data.conversation);
        }
      });
  }

  prepareConversation(conversation) {
    //console.log(this.currentChatConversation, this.currentConversationId, this.currentContextId, conversation);
    if (this.currentConversationId !== conversation.id) {
      return;
    }
    const firstTimeLoaded = this.currentChatConversation ? false : true;
    this.currentChatConversation = conversation;
    if (!this.currentChatConversation.messages) {
      this.currentChatConversation.messages = [];
    }
    this.messages = this.currentChatConversation.messages;
    if (this.notificationCheckMessage && this.messages.findIndex(m => m.id === this.notificationCheckMessage.id) === -1) {
      this.messages.unshift(this.notificationCheckMessage);
    }
    if (this.richMessage && this.messages.findIndex(m => m.id === this.richMessage.id) === -1) {
      this.messages.unshift(this.richMessage);
    }
    if (this.currentChatConversation.initialMessage && this.messages.findIndex(m => m.id === this.currentChatConversation.initialMessage.id) === -1) {
      if (this.currentChatConversation.initialMessage.createdBy.email === this.currentUser.email) {
        this.currentChatConversation.initialMessage.isMine = true;
      }
      this.messages.unshift(this.currentChatConversation.initialMessage);
    }
    if (this.startingMessageInputDialog && this.messages.findIndex(m => m.id === this.startingMessageInputDialog.id) === -1) {
      this.messages.unshift(this.startingMessageInputDialog);
    }
/*    if (firstTimeLoaded && this.currentContextId) {
      this.subscribeToContextIdChannel();
    }*/
  }

  subscribeToContextIdChannel() {
     this.socketClusterService.subscribeToChannel(this.currentContextId).pipe(takeUntil(this.ngUnsubscribe)).subscribe((notification)=>{
       //console.log('get message in currentContextId subscription:', notification);
      this.fetchConversation();
    });
    // this.socketClusterService.subscribeToChannel(this.currentContextId, function (notification) {
    //   // console.log('Notification recieved directly to socket at support chat', notification);
    //   this.fetchConversation();
    // }.bind(this));
  }

  initiate() {
    this.newIssueTypes = Object.values(SupportIssues);
    // this.selectedIssue = (this.data.selectedIssue) ? this.data.selectedIssue : 'Technical Support';
    // this.defaultText = this.data.text ? this.data.text : "";
    this.messages = [];
    this.systemMessages = [];
    this.showMessageInitialization = true;
    this.systemMessages.push({
      message: 'Thanks for contacting Orbitax. So that we can handle your request as efficiently as possible, please select from the following options.',
      isMine: false,
      isTemporary: true,
      createdDate: new Date(),
      systemMessageType: 'NON_SYSTEM_MESSAGE'
    });
  }

  getSupportIssueMessage(supportIssue: string):string{
    let message:string;

    switch ( supportIssue ) {
      case SupportIssues.TechnicalSupport:
        message = "Please describe your issue by entering a message below.";
        break;
      case SupportIssues.Feedback:
        message = "Please let us know your feedback by entering a message below.";
        break;
      case SupportIssues.General:
        message = "Please let us know the details of your request by entering a message below.";
        break;
      case SupportIssues.OrbitaxSales:
        message = "Please let us know which Orbitax solutions and tools you are interested in by entering a message below."
        break;
      case SupportIssues.TaxDomain:
        message = "Please let us know the details of your request by entering a message below."
        break;
      case SupportIssues.OrbitaxServices:
        message = "Please let us know which Orbitax Services you are interested in by entering a message below."
        break;
      default:
        message = ""
        break;
    }

    return message;
  }

  onSelectExistingTicket(existingTicket) {
    // console.log('existing ticket selected:', existingTicket, this.ticketsSelectorControl.value);
    this.showMessageInitialization = false;
    this.cleanup();
    this.startingMessageInputDialog = {
      message: 'Please provide additional details for this issue by entering a message below.',
      isMine: false,
      isTemporary: true,
      createdDate: new Date(),
      id: Guid.create().toString(),
      systemMessageType: 'NON_SYSTEM_MESSAGE'
    };
    this.messages.push(this.startingMessageInputDialog);
  }

  onSelectNewTicket(newTicket) {
    // console.log('new ticket selected:', newTicket);
    this.showMessageInitialization = false;
    this.cleanup();
    this.startingMessageInputDialog = {
      message: this.getSupportIssueMessage(newTicket),
      isMine: false,
      isTemporary: true,
      createdDate: new Date(),
      id: Guid.create().toString(),
      systemMessageType: 'NON_SYSTEM_MESSAGE'
    };
    this.messages.push(this.startingMessageInputDialog);
  }

  createTask() {
    if (this.ticketsSelectorControl.value) {
      this.openOldTask();
    } else if (this.newTaskTypeControl.value) {
      this.createNewTask(this.newTaskTypeControl.value);
    }
  }

  cleanup() {
    this.messages = [];
    this.currentChatConversation = null;
    this.disconnectChannel();
    this.currentContextId = null;
    this.currentConversationId = null;
    this.isMessageInitialized = false;
  }

  disconnectChannel() {
    if (this.currentContextId) {
      this.socketClusterService.unsubscribeChannel(this.currentContextId);
    }
  }

  private handleNewMessage(newReply: any) {
    if(this.messages && this.messages.length > 0) {
      newReply.isMine = this.currentUser.email === newReply.email;
      let existingMessage = this.messages.find(message => message.id === newReply.id);
      if(existingMessage !== undefined) {
        existingMessage.isTemporary = false;
      } else {
        newReply.isTemporary = false;
        this.messages.push(newReply);
        this.scrollToBottom();
      }
    }
  }

  private handleEditedMessage(editedMessage: any) {
    if(this.messages && this.messages.length > 0) {
      let existingMessage = this.messages.find(message => message.id === editedMessage.id);
      if(existingMessage !== undefined) {
        existingMessage.isEdited = true;
        existingMessage.message = editedMessage.message;
        existingMessage.attachment = editedMessage.attachment;
      }
    }
  }

  private handleDeletedMessage(deletedMessageId: any) {
    if(this.messages && this.messages.length > 0) {
      let existingMessage = this.messages.find(message => message.id === deletedMessageId);
      if(existingMessage !== undefined) {
        existingMessage.isDeleted = true;
      }
    }
  }

  private getPlainText(chatText: any) {
    const tempDivElement = document.createElement('div');
    // Set the HTML content with the given value
    tempDivElement.innerHTML = chatText;
    // Retrieve the text property of the element
    return tempDivElement.textContent || tempDivElement.innerText || '';
  }
}
